import { getFragmentData, graphql } from "../../gql";
import { useQuery } from "@apollo/client";
import { UserOneOnOneClassroomPlanFragment } from "./UserOneOnOneClassroomPlanFragment.ts";

export const GetUser1on1ClassroomPlansQuery = graphql(`
  query getUser1on1ClassroomPlans($userId: String!) {
    getUser1on1ClassroomPlans(userId: $userId) {
      ...UserOneOnOneClassroomPlan
    }
  }
`);

export function useUser1on1ClassroomPlans(userId: string) {
  const { data, loading, refetch } = useQuery(GetUser1on1ClassroomPlansQuery, {
    variables: {
      userId,
    },
    fetchPolicy: "cache-and-network",
  });

  return {
    plans:
      getFragmentData(
        UserOneOnOneClassroomPlanFragment,
        data?.getUser1on1ClassroomPlans,
      ) ?? [],
    loading,
    refetch,
  };
}
